import {
  GET_CRM_RECEIVERS_REQUEST,
  GET_CRM_RECEIVERS_SUCCESS,
  GET_CRM_RECEIVERS_FAILURE,
  LOAD_MORE_CRM_RECEIVERS_REQUEST,
  LOAD_MORE_CRM_RECEIVERS_SUCCESS,
  LOAD_MORE_CRM_RECEIVERS_FAILURE,
  GET_CRM_RECEIVERS_TOTAL_REQUEST,
  GET_CRM_RECEIVERS_TOTAL_SUCCESS,
  GET_CRM_RECEIVERS_TOTAL_FAILURE,
  GET_CRM_COMPANIES_REQUEST,
  GET_CRM_COMPANIES_SUCCESS,
  GET_CRM_COMPANIES_FAILURE,
  LOAD_MORE_CRM_COMPANIES_REQUEST,
  LOAD_MORE_CRM_COMPANIES_SUCCESS,
  LOAD_MORE_CRM_COMPANIES_FAILURE,
  GET_CRM_COMPANIES_TOTAL_REQUEST,
  GET_CRM_COMPANIES_TOTAL_SUCCESS,
  GET_CRM_COMPANIES_TOTAL_FAILURE,
  SET_CRM_FILTERS,
  CLEAR_CRM_FILTERS,
  EXPORT_CRM_RECEIVERS_REQUEST,
  EXPORT_CRM_RECEIVERS_SUCCESS,
  EXPORT_CRM_RECEIVERS_FAILURE,
  EXPORT_CRM_COMPANIES_REQUEST,
  EXPORT_CRM_COMPANIES_SUCCESS,
  EXPORT_CRM_COMPANIES_FAILURE,
  RUN_SAVE_CONNECTIONS_SUCCESS,
  RUN_SAVE_CONNECTIONS_FAILURE,
  RUN_SAVE_CONNECTIONS_REQUEST,
} from './crmActions';

import { LOGOUT } from '../client';

const initialState: any = {
  // Receivers state
  receivers: [],
  receiversTotal: 0,
  receiversLoading: false,
  receiversError: '',
  receiversTotalLoading: false,

  // Companies state
  companies: [],
  companiesTotal: 0,
  companiesLoading: false,
  companiesError: '',
  companiesTotalLoading: false,

  // Filters state
  filters: {
    date: 'lifetime',
    date_range_start: '',
    date_range_end: '',
    start: 0,
    receiver_id: '',
    status: '',
    campaign: '',
    campaign_type: '',
    user: '',
    first_name: '',
    last_name: '',
    username: '',
    email: '',
    phone: '',
    headline: '',
    location: '',
    linkedin_url: '',
    positions: '',
    companies: '',
    tag: '',
    clicked: '',
    connected: '',
    responded: '',
    profile_id: '',
    website: '',
    industry: '',
    name: '',
    type: '',
    description: '',
    employee_count_range: '',
    employee_count: '',
  },

  // Export state
  exportLoading: false,
  exportError: '',

  // Sync state
  syncLoading: false,
  syncError: '',
};

export const crmReducers = (state = initialState, action: any) => {
  switch (action.type) {
    // Receivers actions
    case GET_CRM_RECEIVERS_REQUEST:
      return {
        ...state,
        receiversLoading: true,
        receiversError: '',
      };

    case GET_CRM_RECEIVERS_SUCCESS:
      return {
        ...state,
        receivers: action.receivers,
        receiversLoading: false,
        receiversError: '',
      };

    case GET_CRM_RECEIVERS_FAILURE:
      return {
        ...state,
        receiversLoading: false,
        receiversError: action.error,
      };

    case LOAD_MORE_CRM_RECEIVERS_REQUEST:
      return {
        ...state,
        receiversLoading: true,
        receiversError: '',
      };

    case LOAD_MORE_CRM_RECEIVERS_SUCCESS:
      return {
        ...state,
        receivers: [...action.receivers], //[...state.receivers, ...action.receivers],
        receiversLoading: false,
        receiversError: '',
      };

    case LOAD_MORE_CRM_RECEIVERS_FAILURE:
      return {
        ...state,
        receiversLoading: false,
        receiversError: action.error,
      };

    case GET_CRM_RECEIVERS_TOTAL_REQUEST:
      return {
        ...state,
        receiversTotalLoading: true,
      };

    case GET_CRM_RECEIVERS_TOTAL_SUCCESS:
      return {
        ...state,
        receiversTotal: action.total,
        receiversTotalLoading: false,
      };

    case GET_CRM_RECEIVERS_TOTAL_FAILURE:
      return {
        ...state,
        receiversTotalLoading: false,
      };

    // Companies actions
    case GET_CRM_COMPANIES_REQUEST:
      return {
        ...state,
        companiesLoading: true,
        companiesError: '',
      };

    case GET_CRM_COMPANIES_SUCCESS:
      return {
        ...state,
        companies: action.companies,
        companiesLoading: false,
        companiesError: '',
      };

    case GET_CRM_COMPANIES_FAILURE:
      return {
        ...state,
        companiesLoading: false,
        companiesError: action.error,
      };

    case LOAD_MORE_CRM_COMPANIES_REQUEST:
      return {
        ...state,
        companiesLoading: true,
        companiesError: '',
      };

    case LOAD_MORE_CRM_COMPANIES_SUCCESS:
      return {
        ...state,
        companies: [...action.companies],
        companiesLoading: false,
        companiesError: '',
      };

    case LOAD_MORE_CRM_COMPANIES_FAILURE:
      return {
        ...state,
        companiesLoading: false,
        companiesError: action.error,
      };

    case GET_CRM_COMPANIES_TOTAL_REQUEST:
      return {
        ...state,
        companiesTotalLoading: true,
      };

    case GET_CRM_COMPANIES_TOTAL_SUCCESS:
      return {
        ...state,
        companiesTotal: action.total,
        companiesTotalLoading: false,
      };

    case GET_CRM_COMPANIES_TOTAL_FAILURE:
      return {
        ...state,
        companiesTotalLoading: false,
      };

    // Filter actions
    case SET_CRM_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, ...action.filters },
      };

    case CLEAR_CRM_FILTERS:
      return {
        ...state,
        filters: initialState.filters,
      };

    // Export actions
    case EXPORT_CRM_RECEIVERS_REQUEST:
      return {
        ...state,
        exportLoading: true,
        exportError: '',
      };

    case EXPORT_CRM_RECEIVERS_SUCCESS:
      return {
        ...state,
        exportLoading: false,
        exportError: '',
      };

    case EXPORT_CRM_RECEIVERS_FAILURE:
      return {
        ...state,
        exportLoading: false,
        exportError: action.error,
      };

    case EXPORT_CRM_COMPANIES_REQUEST:
      return {
        ...state,
        exportLoading: true,
        exportError: '',
      };

    case EXPORT_CRM_COMPANIES_SUCCESS:
      return {
        ...state,
        exportLoading: false,
        exportError: '',
      };

    case EXPORT_CRM_COMPANIES_FAILURE:
      return {
        ...state,
        exportLoading: false,
        exportError: action.error,
      };

    // Sync actions

    case RUN_SAVE_CONNECTIONS_REQUEST:
      return {
        ...state,
        syncLoading: true,
        syncError: '',
      };

    case RUN_SAVE_CONNECTIONS_SUCCESS:
      return {
        ...state,
        syncLoading: false,
        syncError: '',
      };

    case RUN_SAVE_CONNECTIONS_FAILURE:
      return {
        ...state,
        syncLoading: false,
        syncError: action.error,
      };

    // Logout action
    case LOGOUT:
      return { ...initialState };

    default:
      return state;
  }
};
